import request from '@/utils/request'

// 查询业务积分分类列表
export function listCategory(query) {
  return request({
    url: '/point/category/list',
    method: 'get',
    params: query
  })
}

// 查询业务积分分类分页
export function pageCategory(query) {
  return request({
    url: '/point/category/page',
    method: 'get',
    params: query
  })
}

// 查询业务积分分类详细
export function getCategory(data) {
  return request({
    url: '/point/category/detail',
    method: 'get',
    params: data
  })
}

// 新增业务积分分类
export function addCategory(data) {
  return request({
    url: '/point/category/add',
    method: 'post',
    data: data
  })
}

// 修改业务积分分类
export function updateCategory(data) {
  return request({
    url: '/point/category/edit',
    method: 'post',
    data: data
  })
}

// 删除业务积分分类
export function delCategory(data) {
  return request({
    url: '/point/category/delete',
    method: 'post',
    data: data
  })
}
